import { Component, OnInit, ViewChild } from '@angular/core';
import { PopupComponent } from '../../../core/components/popup/popup.component';
import { IspvisionService, VisionWs } from '../../../core/services/ispvision.service';
import { UserService } from '../../../core/services/user/user.service';
import { UtilService } from '../../../core/services/util.service';
import { ToasterService } from '../../../core/services/toaster.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '../../../core/services/navigation.service';
@Component({
    selector: 'configurator',
    templateUrl: './configurator.component.html',
    styleUrls: ['./configurator.component.less'],
})
export class ConfiguratorComponent implements OnInit {
    public products: VisionWs.IArticle[];
    public productFeatures: VisionWs.IProductFeature[];
    public productOptionList: VisionWs.IProductOptionReq[];
    public productOptions: VisionWs.IProductOption[];
    public salesPrices: VisionWs.SalesPriceResponse;
    public priceDisplay: string;
    public orderComment: string = '';
    public orderReference: string = '';
    public orderName: string = '';
    public orderFiles: any;
    public conceptFiles: any;
    public reloadForm: boolean = false;
    public maxOptionlistLengthIndex: number;
    public showClearOrderFormBtn: boolean = false;
    public orderStart: boolean = false;
    public showOptions: boolean = false;
    public pageLoaded: boolean = false;

    public static EMPTY_ROW: VisionWs.IProductFeature[] = [];
    public orderTableData: VisionWs.IProductFeature[][] = [];

    public globalOrderTableData: any[] = [];
    public globalOrderCheck: boolean = false;

    public popupMirrorData: any;

    private editableClickMirror: any = null;
    private editGlobalOptionMirror: any = null;

    public title: string = 'Voeg markiezen toe';
    public headerTitle: string = 'Bestelformulier markiezen';
    private tableUpdate: string = '';

    @ViewChild('popupRef') popupRef: PopupComponent;
    @ViewChild('extrasPopup') extrasPopup: PopupComponent;

    constructor(
        public visionWs: IspvisionService,
        public userService: UserService,
        public util: UtilService,
        private toaster: ToasterService,
        private route: ActivatedRoute,
        public navigation: NavigationService
    ) {
        this.route.data.subscribe((data) => {
            this.showOptions = data['type'] === 'markiezen';
            if (!this.showOptions) {
                this.title = 'Voeg kokers en/of profielen toe';
                this.headerTitle = 'Bestelformulier kokers en profielen';
            }
            this.visionWs.setFormPartitioning(data['type']);
        });
    }

    async ngOnInit(): Promise<any> {
        this.pageLoaded = false;
        this.isConcept = false;
        this.productFeatures = [];
        this.productOptionList = [];
        ConfiguratorComponent.EMPTY_ROW = [];
        this.globalOrderTableData = [];
        this.priceDisplay = 'netto';
        this.orderComment = '';
        this.orderReference = '';
        this.orderName = '';
        this.orderFiles = [];
        this.conceptFiles = [];
        this.orderTableData = [];
        this.showClearOrderFormBtn = false;
        this.reloadForm = false;
        this.toaster.autoHide = false;

        let prod = (await this.visionWs.getArticle({
            filter_article_is_product: 1,
            filter_article_code: VisionWs.ARTICLE_CODE_MARKIES,
        })) as VisionWs.ArticleResponse;

        this.products = prod.article;

        let tmp = (await this.visionWs.getProductFeature({
            product_code: VisionWs.ARTICLE_CODE_MARKIES.substring(1),
        })) as VisionWs.IProductFeatureResponse;

        if (tmp.product_feature) {
            for (let opts of tmp.product_feature) {
                switch (opts.step_id) {
                    case 1:
                    case 3:
                        ConfiguratorComponent.EMPTY_ROW.push(opts);
                        break;
                    case 2:
                        if (opts.parent_code == null) {
                            this.globalOrderTableData[opts.pf_code] = {
                                pf_name: opts.pf_name,
                                opts: [],
                            };
                        } else {
                            if (this.globalOrderTableData[opts.parent_code]) {
                                // Ensure value property is initialized
                                if (opts.value === undefined || opts.value === null) {
                                    opts.value = '';
                                }
                                this.globalOrderTableData[opts.parent_code].opts.push(opts);
                            }
                        }
                        break;
                }
            }
        }

        this.globalOrderTableData = Object.values(this.globalOrderTableData);

        this.orderTableData.push(this.defaultRow);

        // check if there is a existing shopping cart
        let cartData;
        if (this.conceptId) {
            this.isConcept = true;
            let orderData = await this.visionWs.getOrder(this.conceptId);
            if (orderData) {
                cartData = orderData.cart_data;
                this.orderComment = orderData.comment;
                this.orderReference = orderData.reference;
                this.orderName = orderData.name;
                this.conceptFiles = orderData.files;
            }
        } else {
            this.isConcept = false;
            cartData = await this.visionWs.getShoppingCart();
        }

        if (cartData.orderTableData && cartData.globalOrderTableData) {
            this.globalOrderTableData = cartData.globalOrderTableData;
            this.orderTableData = cartData.orderTableData;
            this.showClearOrderFormBtn = true;
        }

        this.pageLoaded = true;
        this.orderStart = false;

        /**
         * !! OVERRIDES PROD DATA WITH TEST DATA !!
         */
        // const testData = require('./testdata.js');
        // this.orderTableData = testData.ordersTestData;
        // this.globalOrderTableData = testData.globalOptionsTestData;
        this.updateTableColumns();
    }

    private async updateTableColumns(row?: number, forceUpdateAll?: boolean): Promise<void> {
        const uniqueId = this.updateTable();
        this.preSaveCart();

        let popUpdate =
            this.popupOptions && (this.editableClickMirror !== null || this.editGlobalOptionMirror !== null);

        if (popUpdate) {
            let rowOptions: Array<VisionWs.IProductOptionReq[]> = [];
            let canUpdate: boolean = !this.popupOptions || popUpdate;
            let shouldUpdate: boolean = canUpdate;

            let newPopUpdata: any[] = [];
            let currentData = JSON.parse(JSON.stringify(this.orderTableData));

            for (let i = 0; i < currentData.length; i++) {
                let data = currentData[i];
                let product_option_list = this.getOptionArray(i);
                rowOptions.push(product_option_list);

                if (row !== undefined && row !== null) {
                    canUpdate = row === i;
                }

                if (canUpdate) {
                    for (let dat of data) {
                        if (dat.feature_type == 2) {
                            // Find matching popup data once to avoid duplicate searches
                            const matchingPopupData = popUpdate
                                ? this.popupMirrorData.find(
                                      (f) =>
                                          this.editableClickMirror &&
                                          this.editableClickMirror[0] === i &&
                                          f.pf_code === dat.pf_code &&
                                          f.parent_code === dat.parent_code
                                  )
                                : null;

                            // Update options if no filter is provided, or if the current item matches the filter
                            shouldUpdate = !popUpdate || !!matchingPopupData;

                            if (!popUpdate) {
                                shouldUpdate = !shouldUpdate
                                    ? shouldUpdate
                                    : !dat.value || popUpdate
                                    ? true
                                    : dat.value && dat.error;

                                if (forceUpdateAll) {
                                    shouldUpdate = !shouldUpdate;
                                }
                            }

                            if (shouldUpdate) {
                                let productOptions = (await this.visionWs.getProductOption({
                                    feature_code: dat.pf_code,
                                    product_code: VisionWs.PRODUCT_CODE_MARKIES,
                                    maximum_number_of_options: 99999,
                                    product_option_list: product_option_list,
                                })) as VisionWs.IProductOptionResponse;

                                // check if the tableUpdate id has changed during the async calls
                                if (this.tableUpdate !== uniqueId) {
                                    return;
                                }

                                dat.options = productOptions.option_list;
                                dat.value = matchingPopupData?.value ?? dat.value ?? '';
                                dat.maxHeight = productOptions.maxHeight;
                                dat.info = productOptions.info;

                                if (dat.value && dat.options) {
                                    let found = false;
                                    dat.error = true;
                                    for (let opt of dat.options) {
                                        if (opt.code == dat.value) {
                                            found = true;
                                            dat.error = false;
                                        }
                                    }

                                    if (!found) {
                                        dat.value = '';
                                    }
                                }

                                dat.disabled = this.optsDisabled(dat);

                                if (dat.disabled) {
                                    dat.error = false;
                                }

                                newPopUpdata.push(dat);
                            }
                        }
                    }
                }
            }

            // check if the tableUpdate id has changed during the async calls
            if (this.tableUpdate !== uniqueId) {
                return;
            }

            popUpdate = (popUpdate && newPopUpdata.length > 0) || false;

            if (popUpdate) {
                this.popupMirrorData = newPopUpdata;
                return;
            }

            this.orderTableData = currentData;

            popUpdate = this.popupOptions && this.editGlobalOptionMirror;
            currentData = JSON.parse(JSON.stringify(this.globalOrderTableData));
            newPopUpdata = [];

            for (let dat of currentData) {
                for (let d of dat.opts) {
                    const matchingPopupData = popUpdate
                        ? this.popupMirrorData.find(
                              (f) => f.pf_code === d.pf_code && f.parent_code === d.parent_code
                          )
                        : null;
                    shouldUpdate = (!popUpdate || !!matchingPopupData) as boolean;

                    if (!popUpdate) {
                        shouldUpdate = !shouldUpdate
                            ? shouldUpdate
                            : !dat.value || popUpdate
                            ? true
                            : dat.value && dat.error;

                        if (forceUpdateAll) {
                            shouldUpdate = !shouldUpdate;
                        }
                    }

                    if (shouldUpdate) {
                        let allOptions: VisionWs.IProductOption[] = [];
                        for (let opts of rowOptions) {
                            const productOptions = (await this.visionWs.getProductOption({
                                feature_code: d.pf_code,
                                product_code: VisionWs.PRODUCT_CODE_MARKIES,
                                maximum_number_of_options: 99999,
                                product_option_list: opts,
                            })) as VisionWs.IProductOptionResponse;

                            // check if the tableUpdate id has changed during the async calls
                            if (this.tableUpdate !== uniqueId) {
                                return;
                            }

                            allOptions = allOptions.concat(productOptions.option_list);

                            d.maxHeight = productOptions.maxHeight;
                            d.info = productOptions.info;
                        }

                        // Maak de array uniek op basis van code
                        const uniqueOptions = allOptions.filter(
                            (option, index, self) => index === self.findIndex((o) => o.code === option.code)
                        );

                        d.options = uniqueOptions;
                        d.value = matchingPopupData?.value ?? d.value ?? '';

                        if (d.value && d.options) {
                            let found = false;
                            d.error = true;
                            for (let opt of d.options) {
                                if (opt.code == d.value) {
                                    found = true;
                                    d.error = false;
                                }
                            }

                            if (!found) {
                                d.value = '';
                            }
                        }

                        d.disabled = this.optsDisabled(d);

                        newPopUpdata.push(d);
                    }
                }
            }

            // check if the tableUpdate id has changed during the async calls
            if (this.tableUpdate !== uniqueId) {
                return;
            }

            if (popUpdate) {
                this.popupMirrorData = newPopUpdata;
                return;
            }

            this.globalOrderTableData = currentData;

            if (!popUpdate && !forceUpdateAll) {
                this.updateTableColumns(row, true);
                return;
            }
        } else {
            const results = (await this.visionWs.updateTableColumns(
                this.orderTableData,
                this.globalOrderTableData
            )) as any;

            // Ensure the response includes orderTableData and globalOrderTableData
            if (results && results.orderTableData && results.globalOrderTableData) {
                this.orderTableData = results.orderTableData;
                this.globalOrderTableData = results.globalOrderTableData;
            }
        }

        this.updateStepThreeOptions();
        await this.refreshProductPrices();

        this.detectEmptyFields();
    }

    public get emptyRow(): any[] {
        return ConfiguratorComponent.EMPTY_ROW;
    }

    public checkConfiguredProduct(row: number): number {
        if (!this.orderTableData[row]) return 0;
        return this.orderTableData[row].filter((x) => (x.value && x.value > 0) || x.value.length > 0).length;
    }

    public async nextTableRow(): Promise<boolean> {
        var row = 0;
        for (const options of this.orderTableData) {
            let filled = this.checkConfiguredProduct(row);
            if (filled <= 6 && this.showOptions) {
                if (row == 0) {
                    this.globalOrderCheck = false;
                }
                return false;
            } else if (!this.globalOrderCheck && row == 0) {
                this.globalOrderCheck = true;
            }
            row++;
        }
        return true;
    }

    private setAutoValues(): void {
        for (let data of this.orderTableData) {
            for (let row of data) {
                if (row.feature_type != 3 && !row.disabled && (!row.value || row.note)) {
                    if (
                        row.options &&
                        row.options.length === 1 &&
                        this.isCustom(row.options[0].description)
                    ) {
                        row.value = row.options[0].code;
                        row.autohide = true;

                        if (row.note) {
                            row.autohide = false;
                        }
                    }
                }
            }
        }
    }

    public get buttonDisabled(): boolean {
        // First set all auto-values
        this.setAutoValues();
        this.detectEmptyFields();

        // Then check if there are any empty fields
        for (let data of this.orderTableData) {
            for (let row of data) {
                if (!this.optsDisabled(row) && row.feature_type != 3 && !row.disabled && !row.value) {
                    return true;
                }
            }
        }

        for (let data of this.globalOrderTableData) {
            for (let opt of data.opts) {
                if (!opt.disabled && !opt.value) {
                    return true;
                }
            }
        }

        return false;
    }

    public cancelPopupForm(popupRef: PopupComponent): void {
        this.closePopupForm(popupRef);
        this.updateTableColumns();
    }

    public updatePriceDisplay(value): void {
        this.priceDisplay = value;
        this.refreshProductPrices();
    }

    public get defaultRow(): any[] {
        let copy = JSON.parse(JSON.stringify(ConfiguratorComponent.EMPTY_ROW));
        copy[copy.findIndex((x) => x.pf_code == '01')].value = '';
        copy[copy.findIndex((x) => x.pf_code == '02')].value = '';
        copy[copy.findIndex((x) => x.pf_code == '06')].value = '';
        return copy;
    }

    public isCustom(description: string): any {
        return (
            description.charAt(0) === '.' ||
            description === '-' ||
            description === '.' ||
            description.match(/\.{3}/)
        );
    }

    public customInputField(data: any): boolean {
        if (data.feature_type == 3) {
            return true;
        }
        if (data && data.feature_type == 2 && Array.isArray(data.options)) {
            for (let opts of data.options) {
                if (data.value && opts.code == data.value && this.isCustom(opts.description)) {
                    return true;
                }
            }
        }
        data.note = null;
        return false;
    }

    public getSelectedValue(data: any, dataRow: VisionWs.IProductFeature[]): string {
        if (data.feature_type == 1 || data.feature_type == 3) {
            return data.value == 0 ? '' : data.value.toString();
        } else {
            if (!data.options || !Array.isArray(data.options)) {
                return '';
            }
            let descr = '';

            if (!data.disabled) {
                for (let option of data.options) {
                    if (data.value && option.code == data.value) {
                        if (data.note && this.isCustom(option.description)) {
                            return data.note;
                        }

                        if (this.isCustom(option.description) && !data.note) {
                            return '';
                        }

                        return option.description || option.code;
                    }
                }
            }
            if (Array.isArray(dataRow)) {
                for (let row of dataRow) {
                    if (descr === '' && row.parent_code == data.pf_code) {
                        descr = this.getSelectedValue(row, []);
                    }
                }
            }
            if (descr === '') {
                data.value = '';
            }
            return descr;
        }
    }

    public altSelectOptions(options: VisionWs.IExtraOptions[], pfCode: string): any[] {
        let results: any[] = [];
        if (!options || !Array.isArray(options)) return results;
        for (let opt of options) {
            if (!opt) continue;
            results.push({
                id: opt.code,
                value: opt.description,
            });
        }
        return results;
    }

    private validatePopupForm(): boolean {
        this.visionWs.error = '';

        let result = true;
        let fields: string[] = [];

        if (Array.isArray(this.popupMirrorData)) {
            for (let data of this.popupMirrorData) {
                data.error = false;
                if (data.feature_type == 2 && data.options) {
                    if (!data.disabled && !this.optsDisabled(data)) {
                        if (!data.value) {
                            data.error = true;
                            result = false;
                            fields.push(data.pf_desc);
                        }
                        for (let option of data.options) {
                            if (
                                data.value &&
                                option.code == data.value &&
                                this.isCustom(option.description) &&
                                !data.note
                            ) {
                                data.error = true;
                                result = false;
                                fields.push(data.pf_desc);
                            }
                        }
                    }
                }
            }
        }
        if (fields.length > 0) {
            this.visionWs.error = 'De volgende velden zijn niet ingevuld: ' + fields.join(', ') + '.';
        }

        return result;
    }

    public optsDisabled(data: VisionWs.IProductFeature): boolean {
        if (!data.options) {
            return false;
        }
        const hasNoOptions = data.options.length === 0;
        const hasOneOption = data.options.length === 1;

        let isFirstOptionNVT = false;
        let isFirstOptionCustom = false;
        let isCustom = false;

        if (hasOneOption) {
            const firstOptionDescription = data.options[0].description;
            isFirstOptionNVT = /n\.?v\.?t/i.test(firstOptionDescription);
            isCustom = this.isCustom(firstOptionDescription);
            isFirstOptionCustom = !data.maxHeight && isCustom;
            if (isCustom && firstOptionDescription.match(/advies/i)) {
                isCustom = false;
            }
        }

        if (data.pf_code === '08' && !this.showOptions) {
            return false;
        }

        return hasNoOptions || (hasOneOption && !isCustom && (isFirstOptionCustom || isFirstOptionNVT));
    }

    public detectEmptyFields(): void {
        this.setAutoValues();
        let firstValueFound = false;

        if (
            Array.isArray(this.globalOrderTableData) &&
            this.checkConfiguredProduct(0) > 6 && // only check global options if the first product has more than six options filled in, to prevent confusion when filling in the first product
            this.globalOrderTableData.length > 0
        ) {
            for (let i = this.globalOrderTableData.length - 1; i >= 0; i--) {
                let row = this.globalOrderTableData[i];
                if (!row || !row.opts) continue;
                let keys = Object.keys(row.opts); // Get the keys of the object
                for (let a = keys.length - 1; a >= 0; a--) {
                    let key = keys[a];
                    let opt = row.opts[key]; // Get the value with the key

                    if (!opt) continue;
                    opt.isEmpty = false;
                    if (!opt.autohide && !opt.disabled) {
                        if (firstValueFound && !opt.value) {
                            opt.isEmpty = true;
                        }
                        if (!firstValueFound && opt.value) {
                            firstValueFound = true;
                        }
                    }
                }
            }
        }

        if (Array.isArray(this.orderTableData)) {
            for (let i = this.orderTableData.length - 1; i >= 0; i--) {
                let row = this.orderTableData[i];
                if (!row) continue;
                let keys = Object.keys(row); // Get the keys of the object

                for (let a = keys.length - 1; a >= 0; a--) {
                    let key = keys[a];
                    let opt = row[key]; // Get the value with the key

                    if (!opt) continue;
                    opt.isEmpty = false;

                    if (opt.feature_type == 3) {
                        continue;
                    }

                    if (!opt.autohide && !opt.parent_code && opt.step_id === 1 && !opt.disabled) {
                        if (firstValueFound && !opt.value) {
                            opt.isEmpty = true;
                        }
                        if (!firstValueFound && opt.value) {
                            firstValueFound = true;
                        }
                    }
                }
            }
        }
    }

    public checkOnInputValue(ev: Event, data: VisionWs.IProductFeature): string {
        this.visionWs.error = '';
        const target = ev.target as HTMLInputElement;
        const inputValue = parseInt(target.value, 10) || 0;

        if (data.pf_code === '09' && data.feature_type == 2 && data.options) {
            const descriptions = data.options
                .map((option) => parseInt(option.description, 10))
                .filter((value) => !isNaN(value));
            data.max_value = Math.max(...descriptions);
        }
        let message: string | null = null;

        let value = target.value;
        if (
            data.feature_type == 2 &&
            data.pf_code === '66' &&
            data.maxHeight &&
            inputValue > data.maxHeight
        ) {
            value = data.maxHeight.toString();
            message = `De maximale hoogte is ${data.maxHeight} cm.`;
        } else {
            if (data.min_value != 0 && inputValue < data.min_value) {
                value = data.min_value.toString();
                message = `De minimale ${data.pf_name.toLowerCase()} is ${data.min_value} mm.`;
            }

            if (data.max_value != 0 && inputValue > data.max_value) {
                value = data.max_value.toString();
                message = `De maximale ${data.pf_name.toLowerCase()} is ${data.max_value} mm.`;
            }
        }
        if (message) {
            this.visionWs.error = message;
        }
        return value;
    }

    public async updateFormValues(popupRef: PopupComponent): Promise<void> {
        if (!this.validatePopupForm()) {
            return;
        }

        const editableRow = this.editableClickMirror ? this.editableClickMirror[0] : null;

        if (this.editableClickMirror) {
            let currentOrderTableData = JSON.parse(JSON.stringify(this.orderTableData));
            // Update orderTableData values based on pf_code and parent_code from popupMirrorData
            for (let i of Object.keys(currentOrderTableData[this.editableClickMirror[0]])) {
                let orderItem = currentOrderTableData[this.editableClickMirror[0]][i];
                let popupItem = this.popupMirrorData.find(
                    (item) => item.pf_code === orderItem.pf_code && item.parent_code === orderItem.parent_code
                );
                if (popupItem) {
                    currentOrderTableData[this.editableClickMirror[0]][i] = popupItem;
                }
            }
            this.orderTableData = currentOrderTableData;
        }

        if (this.editGlobalOptionMirror) {
            // Update global options with popup mirror data

            let currentGlobalOrderTableData = JSON.parse(JSON.stringify(this.globalOrderTableData));
            for (let i of Object.keys(currentGlobalOrderTableData)) {
                let globalRow = currentGlobalOrderTableData[i];

                for (let j of Object.keys(globalRow.opts)) {
                    let globalOpt = globalRow.opts[j];
                    let popupItem = this.popupMirrorData.find(
                        (item) =>
                            item.pf_code === globalOpt.pf_code && item.parent_code === globalOpt.parent_code
                    );

                    if (popupItem) {
                        currentGlobalOrderTableData[i].opts[j] = popupItem;
                    }
                }
            }
            this.globalOrderTableData = currentGlobalOrderTableData;
        }

        this.showClearOrderFormBtn = true;

        this.orderStart = true;

        this.closePopupForm(popupRef);

        await this.updateShoppingCart();

        await this.updateTableColumns(editableRow);
        this.orderStart = false;
    }

    private async updateShoppingCart(): Promise<void> {
        if (this.isConcept && this.conceptId) {
            this.visionWs.disableConceptSaveMessage = true;
            return this.sendOrder(true);
        }
        await this.visionWs.updateShoppingCart(this.orderTableData, this.globalOrderTableData);
    }

    public closePopupForm(popupRef: PopupComponent): void {
        this.visionWs.error = '';
        this.popupMirrorData = null;
        this.editableClickMirror = null;
        this.editGlobalOptionMirror = null;

        popupRef.closePopup();
    }

    public updateTable(): string {
        const uniqueId = Math.random().toString(36).substring(2);
        this.tableUpdate = uniqueId;
        return uniqueId;
    }

    public async editableClick(tableOptionDataIdx: number, data: any, stepId?: number): Promise<void> {
        // filter data from step id
        if (stepId) {
            let newData: any[] = [];
            for (let val of data) {
                if (val.step_id == stepId) {
                    newData.push(val);
                }
            }
            data = newData;
        }

        this.visionWs.resetPopup();

        let optsData: any[] = [];
        for (let val of data) {
            if (!val.disabled) {
                optsData.push(val);
            }

            for (let opt of this.orderTableData[tableOptionDataIdx]) {
                if (val.pf_code == opt.parent_code) {
                    optsData.push(opt);
                }
            }
        }

        data = optsData;

        this.editableClickMirror = [tableOptionDataIdx, data, stepId];
        this.editGlobalOptionMirror = null;

        this.popupMirrorData = JSON.parse(JSON.stringify(data));

        this.popupRef.erf.nativeElement.classList.remove('hide');

        await this.updateTableColumns();
    }

    public hasOptions(data: any): boolean {
        if (!data || !Array.isArray(data)) return false;
        for (const opts of data) {
            if (opts && opts.value && opts.step_id == 3) {
                return true;
            }
        }
        return false;
    }

    private getOptionArray(idx: number | null = null): VisionWs.IProductOptionReq[] {
        let optionArray: VisionWs.IProductOptionReq[] = [];
        if (idx === null) {
            return optionArray;
        }

        for (const option of this.orderTableData[idx]) {
            let mirrorValue = this.popupMirrorData?.find(
                (f) =>
                    this.editableClickMirror &&
                    this.editableClickMirror[0] === idx &&
                    f.pf_code === option.pf_code &&
                    f.parent_code === option.parent_code
            )?.value;

            let value = !mirrorValue ? option.value : mirrorValue;

            if (option.feature_type == 1 && value > 0)
                optionArray.push({
                    feature_code: option.pf_code,
                    num_value: value,
                } as VisionWs.IProductOptionReq);

            if (option.feature_type == 2 && value > 0)
                optionArray.push({
                    feature_code: option.pf_code,
                    option_code: value,
                } as VisionWs.IProductOptionReq);
        }

        for (const column of this.globalOrderTableData) {
            for (const option of column.opts) {
                let mirrorValue = this.popupMirrorData?.find(
                    (f) => f.pf_code === option.pf_code && f.parent_code === option.parent_code
                )?.value;

                let value = !mirrorValue ? option.value : mirrorValue;

                if (value) {
                    optionArray.push({
                        feature_code: option.pf_code,
                        option_code: value,
                    });
                }
            }
        }

        return optionArray;
    }

    private updateStepThreeOptions(): void {
        if (Array.isArray(this.orderTableData)) {
            for (let row of this.orderTableData) {
                if (!Array.isArray(row)) continue;
                for (let opt of row) {
                    if (opt && opt.step_id && Array.isArray(opt.options) && opt.step_id == 3) {
                        for (let p of opt.options) {
                            if (p && p.description.toLowerCase() === 'nee' && !opt.value) {
                                opt.value = p.code;
                            }
                        }
                    }
                }
            }
        }
    }

    public addTableRow(): void {
        this.orderTableData.push(this.defaultRow);
    }

    public async rowOptionsDelete(tableDataIdx): Promise<void> {
        this.orderTableData.splice(tableDataIdx, 1);
        await this.updateShoppingCart();
        this.ngOnInit();
    }

    public async rowOptionsDuplicate(tableDataIdx): Promise<void> {
        this.orderTableData.push(JSON.parse(JSON.stringify(this.orderTableData[tableDataIdx])));
        await this.updateShoppingCart();
        this.refreshProductPrices();
    }

    public getTableClasses(option: any, d: VisionWs.IProductFeature, r: VisionWs.IProductFeature[]): string {
        let className = 'editable';

        if (option == null) {
            className = 'empty';
        } else if (option.toString().length <= 0 || option <= 0) {
            className = 'empty editable';

            if (d.isEmpty && !d.disabled) {
                className += ' no-value';
            }
        }

        if (d.feature_type == 2 && !d.parent_code) {
            let optionsFound = [this.optsDisabled(d)];
            for (let row of r) {
                if (row.parent_code == d.pf_code) {
                    optionsFound.push(this.optsDisabled(row));
                }
            }

            if (optionsFound.every((v) => v === true)) {
                d.disabled = true;
            }
        }

        return className;
    }

    public async editGlobalOption(option: {
        pf_code: string;
        pf_name: string;
        feature_type: number;
        value: string;
        disabled: boolean;
        options: VisionWs.IProductOption[];
    }): Promise<void> {
        if (option.disabled) {
            return;
        }

        this.editableClickMirror = null;

        this.visionWs.resetPopup();

        if (option.options.length > 0) {
            this.popupRef.erf.nativeElement.classList.remove('hide');
        } else {
            option.disabled = true;
        }
        this.editGlobalOptionMirror = option;
        this.popupMirrorData = JSON.parse(JSON.stringify([option]));

        this.updateTableColumns();
    }

    public get popupOptions() {
        if (this.popupMirrorData && Array.isArray(this.popupMirrorData)) {
            let optsDisabled = true;
            for (let data of this.popupMirrorData) {
                if (this.optsDisabled(data)) {
                    data.disabled = true;
                }

                if (!data.disabled) {
                    optsDisabled = false;
                }
            }
            return this.popupMirrorData[0] && !optsDisabled;
        }
        return false;
    }

    public async preCheckOptions(i: number, event: string): Promise<void> {
        await this.updateTableColumns();
        this.updateStepThreeOptions();
    }

    private preSaveCart(): void {
        for (let rows of this.orderTableData) {
            let isElectric = false;
            let isWooden = false;
            let needUpdate = false;
            let stormlat = null;

            for (let data of rows) {
                let value = this.getSelectedValue(data, rows);
                if (data.pf_name === 'Bediening') {
                    isElectric = value === 'Elektrisch';
                }

                if (data.pf_name === 'Zijkappen') {
                    isWooden = value.startsWith('HH');
                }

                if (data.pf_name === 'Stormlat') {
                    needUpdate = value === 'Nee' || value === '';
                    stormlat = data;
                }
            }

            if (stormlat && needUpdate && isElectric && isWooden) {
                stormlat.value = '01';

                let foundTrueOption = false;
                for (let opt of stormlat.options) {
                    if (opt.description === 'Ja') {
                        foundTrueOption = true;
                    }
                }

                if (!foundTrueOption) {
                    stormlat.options = [
                        {
                            code: '01',
                            description: 'Ja',
                        },
                    ];
                }
            }
        }
    }

    private validate(): boolean {
        this.toaster.toasterActive = false;
        // order validation before sending

        let maxWidth = 0;

        // Grenen: maximaal 420cm breed en max uitval 200cm

        // Hardhouten (2): maximaal 500cm breed en max uitval 200cm
        // Aluminium (3): maximaal 700cm breed en max uitval 200cm
        // Klapmodel: maximaal 700cm breed en max uitval 200cm
        // Pet model: maximaal 700cm breed en max uitval 200cm

        for (let rows of this.orderTableData) {
            for (let data of rows) {
                if (data.pf_name === 'Model') {
                    for (let opt of data.options) {
                        if (data.value && opt.code == data.value) {
                            if (
                                opt.description.trim() === 'Klap model' ||
                                opt.description.trim() === 'Pet model'
                            ) {
                                maxWidth = maxWidth < 7000 ? maxWidth : 7000;
                            }
                        }
                    }
                    break;
                }
            }
        }

        for (let row of this.globalOrderTableData) {
            if (row.pf_name === 'Frame') {
                for (let opt of row.opts) {
                    if (opt.pf_code === '05') {
                        for (let o of opt.options) {
                            if (o.code == opt.value) {
                                if (o.description.trim() === 'Hardhout') {
                                    maxWidth = 5000;
                                }
                                if (o.description.trim() === 'Grenenhout') {
                                    maxWidth = 4200;
                                }
                                if (o.description.trim() === 'Aluminium') {
                                    maxWidth = 7000;
                                }
                            }
                        }
                    }
                }
                break;
            }
        }

        if (maxWidth > 0) {
            let showError = false;

            for (let rows of this.orderTableData) {
                for (let data of rows) {
                    if (data.pf_name === 'Uitval') {
                        for (let opt of data.options) {
                            if (data.value && opt.code == data.value) {
                                if (parseInt(opt.description.trim()) > 2000) {
                                    showError = true;
                                }
                            }
                        }
                    }
                    if (data.pf_name === 'Breedte') {
                        if (data.value > maxWidth) {
                            showError = true;
                        }
                    }
                }
            }

            if (showError) {
                this.toaster.error(
                    'Deze maat valt buiten de standaard prijstabel, neem contact met ons op voor de mogelijkheden'
                );
                return false;
            }
        }
        return true;
    }

    public async sendOrder(isConcept: boolean = false): Promise<void> {
        this.isConcept = isConcept;
        if (!this.isConcept) {
            if (this.buttonDisabled || this.orderStart || !this.validate()) {
                return;
            }
        }

        this.preSaveCart();

        if (!this.isConcept) {
            this.orderStart = true;
        }

        let orderForm = new FormData();
        orderForm.append('comment', this.orderComment);
        orderForm.append('reference', this.orderReference);
        orderForm.append('name', this.orderName);
        orderForm.append('productCode', VisionWs.PRODUCT_CODE_MARKIES);
        orderForm.append('globalOrderTableData', JSON.stringify(this.globalOrderTableData));
        orderForm.append('orderTableData', JSON.stringify(this.orderTableData));
        orderForm.append('isConcept', this.isConcept ? '1' : '0');
        if (this.conceptId) {
            orderForm.append('conceptId', this.conceptId.toString());
        }

        if (this.orderFiles && this.orderFiles.length > 0) {
            for (let i = 0; i < this.orderFiles.length; i++) {
                orderForm.append(`orderFiles[${i}]`, this.orderFiles[i], this.orderFiles[i].name);
            }
        }

        let res = await this.visionWs.sendOrder(orderForm);

        this.orderStart = false;

        if (!res.errors) {
            if (this.isConcept) {
                this.conceptId = res.conceptId;
                return;
            }

            this.reloadForm = true;
            await this.visionWs.clearShoppingCart();
            await this.ngOnInit();
        }
    }

    public async refreshProductPrices(): Promise<void> {
        if (!this.priceDisplay || this.buttonDisabled) {
            return;
        }

        const prices = await this.visionWs.getItemPrices(this.globalOrderTableData, this.orderTableData);
        if (prices) {
            this.salesPrices = prices;
        }

        this.validate();
    }

    public hasRowErrors(code: string, data: any): boolean {
        for (let row of data) {
            if ((row.pf_code == code && row.error) || (row.parent_code == code && row.error)) {
                return true;
            }
        }
        return false;
    }

    public async clearOrderForm(): Promise<void> {
        this.updateTable();
        this.reloadForm = true;
        if (!this.isConcept) {
            await this.visionWs.clearShoppingCart();
        } else {
            // force all fields to be empty
            setTimeout(() => {
                this.conceptId = 0;
                this.isConcept = false;
                this.ngOnInit();
            }, 300);
            return;
        }
        this.ngOnInit();
    }

    public get isConcept(): boolean {
        return this.visionWs.isConcept;
    }

    public set isConcept(value: boolean) {
        this.visionWs.isConcept = value;
    }

    public set conceptId(value: number) {
        this.visionWs.conceptId = value;
    }

    public get conceptId(): number {
        return this.visionWs.conceptId;
    }

    ngOnDestroy(): void {
        this.tableUpdate = Math.random().toString(36).substring(2);
    }
}
